import React, { useState, useEffect } from 'react';
import linkIcon from '../../../assets/images/link.svg'
import {
    fetchShipmentById, fetchLotsByShipmentId, deleteShipmentById, fetchShipments, validateShipmentStockLot, placeShipment,
    resetShipmentState, validateShipmentLotExistence, generateShipmentAutoOrder
} from '../../../redux/shipmentSlice.js'; // Import actions from the slice
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';
import MainTable from '../../../components/Table/PaginationTable';
import { ProductColumnDefDefaultFn, StockColumnDefFn } from '../columns/ColumnDefShipment.js';
import { useParams } from 'react-router-dom';
import { getDate } from '../../../helpers/helperFunction.js';
import placeShipmentIcon from '../../../assets/images/ship.svg';
import editIcon from '../../../assets/images/editIcon.svg';
import xIcon from '../../../assets/images/xmark.svg';
import WarningShipmentModalComponent from "../../../components/Modals/WarningShipmentModalComponent.js";
import AddLotForProductWarningModal from '../../../components/Modals/AddLotForProductWarningModal.js';
import AlertShipmentModal from '../../../components/Modals/AlertShipmentModal.js';
import PoNotFoundModal from '../../../components/Modals/PoNotFoundModal.js';
import { toast } from 'react-hot-toast';

const ShipmentDetails = () => {
    // const shipmentProducts = useSelector(state =>
    //     state.shipment.shipmentDetails && state.shipment.shipmentDetails.data
    //         ? state.shipment.shipmentDetails.data.shipmentProducts
    //         : []);
    // const shipmentDetails = useSelector((state) => state?.shipment?.shipmentDetails?.data || {});
    // const shipmentLots = useSelector((state) => state?.shipment?.stocks?.data || {});
    const shipment = useSelector((state) => state?.shipment || {});
    const shipmentDetails = shipment?.shipmentDetails?.data || {};
    const shipmentProducts = shipment?.shipmentDetails?.data?.shipmentProducts || [];
    const shipmentLots = shipment?.stocks?.data || {};
    const isLinked = shipmentDetails?.isLinked;

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isShipmentAlertModalOpen, setIsShipmentAlertModalOpen] = useState(false);
    const [isValidateLotModalOpen, setIsValidateLotModalOpen] = useState(false);
    const [isPoNotFoundModalOpen, setIsPoNotFoundModalOpen] = useState(false);
    const [message, setMessage] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { shipmentId } = useParams();
    const productColumn = ProductColumnDefDefaultFn();
    const stockColumn = StockColumnDefFn();

    useEffect(() => {
        // console.log("MY shipmentId ",shipmentId); 
        dispatch(fetchShipmentById({ shipmentId, type: 'view' }))
            .then(() => {
                // console.log("shipmentProducts",shipmentProducts);
            });
        dispatch(fetchLotsByShipmentId({ shipmentId, type: 'product-lots' }))
            .then(() => {
                // console.log("shipmentLots inside then",shipmentLots);
            });
        // console.log("shipmentLots",shipmentLots);
    }, [dispatch]);

    const onDeleteModalClose = () => {
        setIsDeleteModalOpen(false)
    }

    const onValidateLotModalClose = () => {
        setIsValidateLotModalOpen(false);
    }

    const onShipmentAlertModalClose = () => {
        setIsShipmentAlertModalOpen(false)
    }

    const onPoNotFoundModalClose = () => {
        setIsPoNotFoundModalOpen(false)
    }

    const linkAutoGeneratedOrder = () => {
        try {
            dispatch(generateShipmentAutoOrder({ shipmentId, orderNumber: '', type: "auto-generate" }))
                .then((response) => {
                    // console.log("responseeeeeeeeee",response);
                    if (response.type === 'shipment/generateShipmentAutoOrder/fulfilled') {
                        dispatch(placeShipment({
                            shipmentId: shipmentId,
                            action: 'placeShipment'
                        })).then(() => {
                            navigate('/outbox-shipment');
                        });
                    }
                })
            setIsPoNotFoundModalOpen(false)
            // dispatch(generateShipmentAutoOrder({shipmentId, orderNumber:''}))
        }
        catch(err){
            // console.log("")
            toast.error("Something went wrong!")
        }
    }

    const handleDelete = () => {
        dispatch(deleteShipmentById(shipmentId)).then(
            () => {
                const queryParams = {
                    type: 'outgoing',
                    searchText: '',
                    fromDate: '',
                    toDate: '',
                    shipmentStatus: '',
                    pageSize: 10,
                    pageNumber: 1,
                };
                dispatch(fetchShipments(queryParams))
                    .then(() => {
                        navigate('/outbox-shipment');
                    });
            }
        );
    }

    const handlePlaceShipment = () => {
        setIsShipmentAlertModalOpen(false);
        if (isLinked) {
            dispatch(placeShipment({
                shipmentId: shipmentId,
                action: 'placeShipment'
            })).then(() => {
                navigate('/outbox-shipment');
            });
        } else {
            // console.log("INSIDE ELSE OF HANDLE PLACE SHIPMENT")
            setIsPoNotFoundModalOpen(true);
        }
    }

    const handlePlaceShipmentBtnClick = async () => {
        const response = await validateShipmentStockLot(shipmentId, 'validateStock') // API doesn't seems to be working
        //   console.log("validateShipmentStockLot response",response);
        let place = true;
        const productCount = shipmentProducts.length;
        if (productCount === 0) {
            setMessage("Please Add atleast one product to proceed");
            place = false;
            setIsValidateLotModalOpen(true)
        } else {
            const response = await validateShipmentLotExistence(shipmentId, 'checkLotExists');
            // console.log("response",response);
            if (response === 0) {
                place = false;
                setMessage("Please Add Lot to proceed");
                setIsValidateLotModalOpen(true)
            } else if (response === -1) {
                place = false;
                setMessage("Are you sure you don't want to add lot for all products? Please delete those products for which you don't want to add lot.");
                setIsValidateLotModalOpen(true)
            }
        }
        if (place) {
            setIsShipmentAlertModalOpen(true);
        }
    }

    const handleEditShipmentBtnClick = () => {
        navigate(`/edit-shipment`, { state: { actionType: 'edit', shipmentId: shipmentId } });
    }

    const handleDeleteBtnClick = () => {
        setIsDeleteModalOpen(true);
    }

    return (
        <>
            <div>
                <h1 className="fprimary">Shipment Details </h1>
                <h5 className="">Review the Shipment carefully before placing it.</h5>
            </div>
            <div className="card mt-3 bg-stage">
                <div className="card-body">
                    <div>
                        <p className="font-13 mb-0 text-black-50">Invoice Number:</p>
                        <div className="bg-slash font-14 mb-3">{shipmentDetails?.invoiceNumber}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Invoice Date</p>
                                    <div className="bg-slash font-14">{getDate(shipmentDetails?.invoiceDate)}</div>
                                </div>
                                <div className="ps-2 right-box w-100">
                                    <p className="font-13 mb-0">Buyer</p>
                                    <div className="bg-slash font-14">{shipmentDetails.buyerCompany?.companyName || 'N/A'}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Seller Unit</p>
                                    <div className="bg-slash font-14">{shipmentDetails.sellerCompany?.companyName}</div>
                                </div>
                                <div className="ps-2 right-box w-100">
                                    <p className="font-13 mb-0">Buyer Unit</p>
                                    <div className="bg-slash font-14">{shipmentDetails.buyerCompany?.companyName}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Transport Mode</p>
                                    <div className="bg-slash font-14">{shipmentDetails?.shipmentTransportMode}</div>
                                </div>
                                <div className="left-box w-100 ps-2">
                                    <p className="font-13 mb-0">Link Buyer Purchase</p>
                                    <div className="bg-slash font-14">{shipmentDetails?.orderNumber}</div>
                                    <span className="ms-2"><img src={linkIcon} alt="Link" /></span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="mt-3">
                                <h4 className="font-18">Shipment Description</h4>
                                <p className="font-13">
                                    {shipmentDetails?.shipmentDescription}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='mt-5 ml-2'>
                <h1 className="fprimary">Product Details</h1>
            </div>
            <MainTable
                columns={productColumn}
                data={shipmentProducts}
                enablePagination={false}
                className='mt-3'
            // initialPageSize={pageSize}
            // pageNumber={pageNumber} // Use the correct prop name as expected by MainTable
            // onPageSizeChange={handlePageSizeChange}
            // onPageIndexChange={handlePageIndexChange}
            />
            <div className='mt-5 ml-2'>
                <h1 className="fprimary">Lot Details</h1>
            </div>
            <MainTable
                columns={stockColumn}
                data={shipmentLots}
                enablePagination={false}
                className='mt-3'
            // initialPageSize={pageSize}
            // pageNumber={pageNumber} // Use the correct prop name as expected by MainTable
            // onPageSizeChange={handlePageSizeChange}
            // onPageIndexChange={handlePageIndexChange}
            />
            <div className="d-flex justify-content-between mt-5 mb-5">
                <div>
                    <button type="button" className="btn btn-light grey-btn lg-btn me-3">Upload QA</button>
                    <button className="btn btn-primary greeen-btn">
                        <span><ControlPointOutlinedIcon /></span> Add Job Work
                    </button>
                </div>
                {shipmentDetails.isShipped === 0 && (
                    <div>
                        <button className="icon-clay mr-2 me-2" onClick={handlePlaceShipmentBtnClick}>
                            <img src={placeShipmentIcon} alt="Place Shipment" />
                        </button>

                        <button className="icon-clay mr-2 me-2" onClick={handleEditShipmentBtnClick}>
                            <img src={editIcon} alt="Edit" />
                        </button>

                        <button className="icon-clay mr-2" onClick={handleDeleteBtnClick}>
                            <img src={xIcon} alt="Delete" />
                        </button>
                    </div>
                )}
            </div>
            {isDeleteModalOpen &&
                <WarningShipmentModalComponent
                    isOpen={isDeleteModalOpen}
                    onClose={onDeleteModalClose}
                    handleDelete={handleDelete}
                />
            }
            {isValidateLotModalOpen &&
                <AddLotForProductWarningModal
                    isOpen={isValidateLotModalOpen}
                    onClose={onValidateLotModalClose}
                    message={message}
                />}
            {isShipmentAlertModalOpen &&
                <AlertShipmentModal
                    isOpen={isShipmentAlertModalOpen}
                    onClose={onShipmentAlertModalClose}
                    handlePlaceShipment={handlePlaceShipment}
                // isLinked={isLinked}
                />}
            {isPoNotFoundModalOpen &&
                <PoNotFoundModal
                    isOpen={isPoNotFoundModalOpen}
                    onClose={onPoNotFoundModalClose}
                    linkAutoGeneratedOrder={linkAutoGeneratedOrder}
                />
            }
        </>
    );
};

export default ShipmentDetails;
